import React from 'react';
import { Link } from 'react-router-dom';
// MATERIAL-UI
import Typography from '@mui/material/Typography';
// COMPONENTS
import EmptyState from '../common/EmptyState';

const NotFound = () => {
  const pageText = (
    <div>
      <Typography variant="body1">That page does not exist.</Typography>
      <Link to="/">Home</Link>
    </div>
  );

  return <EmptyState pageTitle="Not Found" pageText={pageText} />;
};

export default NotFound;
